module.exports = __webpack_public_path__ + "fonts/FuturaStd-Heavy.551fb015.woff2";